module.exports = __webpack_public_path__ + "static/media/gymnastics-ireland.6725848c.png";